import { QueryClient } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60,
      retry: 2,
      refetchOnWindowFocus: true,
    },
    mutations: {
      onError(error: Error) {
        Sentry.captureException(error);
      },
    },
  },
});
